import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import UnitSlideShow from "./UnitSlideShow"; // Slayt gösterisi bileşeni

function DynamicContent({ title, subtitle }) {
  const [contentData, setContentData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data, error } = await supabase
          .from("headings")
          .select("*")
          .eq("title", title)
          .eq("subtitle", subtitle)
          .single();

        if (error) {
          console.error("Veri çekilirken hata:", error);
        } else {
          setContentData(data);
        }
      } catch (err) {
        console.error("Beklenmedik bir hata oluştu:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, [title, subtitle]);

  if (loading) return <p>Yükleniyor...</p>;

  if (!contentData) return <p>İçerik bulunamadı.</p>;

  return (
    <div className="container section-container">
      <div className="text-section">
        <h1>{contentData.subtitle}</h1>
        <p dangerouslySetInnerHTML={{ __html: contentData.content }} />
      </div>
      {/* Slayt gösterisi */}
      <UnitSlideShow unitId={contentData.id} />
    </div>
  );
}

export default DynamicContent;
